// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-6e288dce]{border-bottom:dashed 1px var(--el-text-color-secondary);border-radius:0}", ""]);
// Exports
module.exports = exports;
